const PropertyType = ({ display = '', code = 0 } = {}) => ({
  display: display,
  code: code,
});

const Price = ({ price = '' } = {}) => ({
  price: price,
});

const PremiumPricingGuidance = ({
  beds = null,
  propertyType = {},
  zip = '',
  city = '',
  state = '',
  property = {},
  marketMedian = {},
  marketMin = {},
  marketMax = {},
  market25thPercentile = {},
  market75thPercentile = {},
  rentZestimateRangeLow = {},
  rentZestimateRangeHigh = {},
} = {}) => ({
  beds: beds,
  propertyType: PropertyType(propertyType),
  zip: zip,
  city: city,
  state: state,
  property: Price(property),
  marketMedian: Price(marketMedian),
  marketMin: Price(marketMin),
  marketMax: Price(marketMax),
  market25thPercentile: Price(market25thPercentile),
  market75thPercentile: Price(market75thPercentile),
  rentZestimateRangeLow: Price(rentZestimateRangeLow),
  rentZestimateRangeHigh: Price(rentZestimateRangeHigh),
});

export default PremiumPricingGuidance;

export type PremiumPricingGuidanceProps = ReturnType<typeof PremiumPricingGuidance>;
